import React, { useCallback, useContext, useEffect, useState } from 'react'
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Menu from '../../components/Menu';
import axios from 'axios';
import { LoadingContext } from '../../context/LoadingContext';
import ReactLoader from '../../components/ReactLoader';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
const config = require('../../config.json')

export default function Statments({ ipAddress, loginData }) {
    const [account, setAccount] = useState(loginData?.ulid);
    const [business, setBusiness] = useState({});
    const [loading, setLoading] = useContext(LoadingContext)
    const handleLoad = useCallback(() => {
        setLoading(true)
        let data = JSON.stringify({
            "ip": ipAddress,
            "ulid": loginData.ulid
        });

        let axiosConfig = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${config.baseUrl}/statment`,
            headers: {
                'ip': ipAddress,
                'ulid': loginData.ulid,
                'auth': loginData.auth,
                'token': loginData.token,
                'Content-Type': 'application/json'
            },
            data: data
        };
        // console.log(axiosConfig)
        axios.request(axiosConfig)
            .then((response) => {
                setBusiness(response.data.info)
                console.log(response.data)
                setLoading(false)
            })
            .catch((error) => {
                console.log(error);
            });
    }, [account, ipAddress, loginData.auth, loginData.token, loginData.ulid, setLoading])


    useEffect(() => {

        handleLoad()
    }, [handleLoad])


    return (
        <>
            <div className="layout-container">
                <Menu />
                <div className="layout-page">
                    <Header />
                    {loading ? <><ReactLoader /></> :
                        <div className="content-wrapper mb-4">
                            <div className="container-xxl flex-grow-1 container-p-y pt-2">
                                <div className='row'>
                                    <div className="col-md-12  mb-2">
                                        <div className="card">
                                            <div className="card-header align-items-center ">
                                                <div className="card-title mb-0">
                                                    <h6 className="m-0 me-2 text-center text-black">Dear {account}, Your Income</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-4 col-md-6 col-sm-6 mb-2">
                                        <div className="card" >
                                            <div className="card-body dashinc mb-1" >
                                                <div className="d-flex justify-content-between">
                                                    <div className="card-info">
                                                        <p className="card-text m-0 text-sm">Total Income</p>


                                                    </div>
                                                    <div className="card-info">
                                                        <div className="d-flex align-items-end ">
                                                            <small className="text-black "><i className='bx bx-rupee bx-xs'></i> {business?.income?.total}</small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6 col-sm-6 mb-2">
                                        <div className="card" >
                                            <div className="card-body dashinc mb-1" >
                                                <div className="d-flex justify-content-between">
                                                    <div className="card-info">
                                                        <p className="card-text m-0 text-sm">Today Income</p>
                                                    </div>
                                                    <div className="card-info">
                                                        <div className="d-flex align-items-end ">
                                                            <small className="text-black "><i className='bx bx-rupee bx-xs'></i> {business?.income?.today}</small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6 col-sm-6 mb-2">
                                        <div className="card" >
                                            <div className="card-body dashinc mb-1" >
                                                <div className="d-flex justify-content-between">
                                                    <div className="card-info">
                                                        <p className="card-text m-0 text-sm">Yesterday Income</p>
                                                    </div>
                                                    <div className="card-info">
                                                        <div className="d-flex align-items-end ">
                                                            <small className="text-black "><i className='bx bx-rupee bx-xs'></i> {business?.income?.yday}</small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6 col-sm-6 mb-2">
                                        <Link to="/direct">
                                            <div className="card" >
                                                <div className="card-body dashinc mb-1" >
                                                    <div className="d-flex justify-content-between">
                                                        <div className="card-info">
                                                            <p className="card-text m-0 text-sm">Diract Income</p>
                                                        </div>
                                                        <div className="card-info">
                                                            <div className="d-flex align-items-end ">
                                                                <small className="text-black "><i className='bx bx-rupee bx-xs'></i> {business?.income?.diract}</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="col-lg-4 col-md-6 col-sm-6 mb-2">
                                        <Link to="/binary">
                                            <div className="card" >
                                                <div className="card-body dashinc mb-1" >
                                                    <div className="d-flex justify-content-between">
                                                        <div className="card-info">
                                                            <p className="card-text m-0 text-sm">Binary Income</p>
                                                        </div>
                                                        <div className="card-info">
                                                            <div className="d-flex align-items-end ">
                                                                <small className="text-black "><i className='bx bx-rupee bx-xs'></i> {business?.income?.binary}</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="col-lg-4 col-md-6 col-sm-6 mb-2">
                                        <Link to="/spbinary">
                                            <div className="card" >
                                                <div className="card-body dashinc mb-1" >
                                                    <div className="d-flex justify-content-between">
                                                        <div className="card-info">
                                                            <p className="card-text m-0 text-sm">Sponsor Binary Income</p>
                                                        </div>
                                                        <div className="card-info">
                                                            <div className="d-flex align-items-end ">
                                                                <small className="text-black "><i className='bx bx-rupee bx-xs'></i> {business?.income?.spbinary}</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="col-lg-4 col-md-6 col-sm-6 mb-2">
                                        <Link to="/reward">
                                            <div className="card" >
                                                <div className="card-body dashinc mb-1" >
                                                    <div className="d-flex justify-content-between">
                                                        <div className="card-info">
                                                            <p className="card-text m-0 text-sm">Reward</p>
                                                        </div>
                                                        <div className="card-info">
                                                            <div className="d-flex align-items-end ">
                                                                <small className="text-black "><i className='bx bx-rupee bx-xs'></i> {business?.income?.reward}</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="col-lg-4 col-md-6 col-sm-6 mb-2">
                                        <Link to="/club">
                                            <div className="card" >
                                                <div className="card-body dashinc mb-1" >
                                                    <div className="d-flex justify-content-between">
                                                        <div className="card-info">
                                                            <p className="card-text m-0 text-sm">Club Royalty</p>
                                                        </div>
                                                        <div className="card-info">
                                                            <div className="d-flex align-items-end ">
                                                                <small className="text-black "><i className='bx bx-rupee bx-xs'></i> {business?.income?.royalty}</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="col-lg-4 col-md-6 col-sm-6 mb-2">
                                        <Link to="/smm">
                                            <div className="card" >
                                                <div className="card-body dashinc mb-1" >
                                                    <div className="d-flex justify-content-between">
                                                        <div className="card-info">
                                                            <p className="card-text m-0 text-sm">SMM Income</p>
                                                        </div>
                                                        <div className="card-info">
                                                            <div className="d-flex align-items-end ">
                                                                <small className="text-black "><i className='bx bx-rupee bx-xs'></i> {business?.income?.smm}</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="col-lg-4 col-md-6 col-sm-6 mb-2">
                                        <Link to="/self">
                                            <div className="card" >
                                                <div className="card-body dashinc mb-1" >
                                                    <div className="d-flex justify-content-between">
                                                        <div className="card-info">
                                                            <p className="card-text m-0 text-sm">Self Genration</p>
                                                        </div>
                                                        <div className="card-info">
                                                            <div className="d-flex align-items-end ">
                                                                <small className="text-black "><i className='bx bx-rupee bx-xs'></i> {business?.income?.roi}</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="col-lg-4 col-md-6 col-sm-6 mb-2">
                                        <Link to="/royalty">
                                            <div className="card" >
                                                <div className="card-body dashinc mb-1" >
                                                    <div className="d-flex justify-content-between">
                                                        <div className="card-info">
                                                            <p className="card-text m-0 text-sm">Royalty Level</p>
                                                        </div>
                                                        <div className="card-info">
                                                            <div className="d-flex align-items-end ">
                                                                <small className="text-black "><i className='bx bx-rupee bx-xs'></i> {business?.income?.rlevel}</small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <Footer />
                        </div>
                    }
                </div>
            </div>
        </>
    );
}
